import { createContext } from 'react';

interface IResetPasswordContext {
  step: number;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
  mfaToken: string;
  setMFAToken: (token: string) => void;
  mfaType: string;
  setMFAType: (token: string) => void;
  maskedPhoneNumber: string;
  setMaskedPhoneNumber: (token: string) => void;
}

export const ResetPasswordContext = createContext<IResetPasswordContext>({
  step: 0,
  goToNextStep: () => undefined,
  goToPreviousStep: () => undefined,
  mfaToken: '',
  setMFAToken: () => undefined,
  mfaType: '',
  setMFAType: () => undefined,
  maskedPhoneNumber: '',
  setMaskedPhoneNumber: () => undefined,
});
